import React, { FC } from "react";
import { Trans } from "@lingui/macro";
import * as styles from "./Footer.module.scss";
import { SectionContainer } from "@silversea-ssc/ui-components-react";
import FollowUs from "components/Footer/components/FollowUs/FollowUs";
import ContactUs from "components/Footer/components/ContactUs/ContactUs";
import Subscribe from "./components/Subscribe/Subscribe";
import FooterNav from "./components/FooterNav/FooterNav";
import SubFooter from "./components/SubFooter/SubFooter";

import { Button } from "@silversea-ssc/ui-components-react";
import getUrlsByLanguage from "src/urls/urls";

import { INavLinks } from "components/HeaderNavBar/type";
import { Language } from "src/utils/localization/languages/types";
import { useGeolocation } from "../../utils/localization/geolocation/GeolocationContext";
import { INavLink } from "../HeaderNavBar/type";

interface FooterProps {
  language: Language;
}

export const Footer: FC<FooterProps> = ({ language }) => {
  const urls = getUrlsByLanguage(language.code);
  const searchUrl = urls.search;

  const geoLocation = useGeolocation();
  if (geoLocation.countryCode == "GB") {
    const travelInformation = urls.footerLinks[1];
    const linkForUK: INavLink = {
      href: "/travel-informations/tax-strategy.html",
      title: "Tax Strategy"
    };
    if (travelInformation && travelInformation.children) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      travelInformation.children.push(linkForUK as any); // NOTE: type check fails if not using any :(
      urls.footerLinks[1] = travelInformation;
    }
  }

  return (
    <React.Fragment>
      <footer className={styles.footer} id="footer" data-content-name="footer">
        <SectionContainer backgroundColor="transparent">
          <div className={styles.mainFooter}>
            <div className={styles.footerLeft}>
              <FollowUs className={styles.followUs} />
              <div className={styles.footerBoxes}>
                <div className={styles.contactUs}>
                  <ContactUs />
                </div>
                <div className={styles.subscribe}>
                  <Subscribe />
                </div>
              </div>
              <div className={styles.ctaContainer}>
                <Button
                  variant="primary"
                  centerText={true}
                  href={urls.serviceLinks.raq.href}
                  full={true}
                  data-content-piece="request_a_quote"
                >
                  <Trans>Request a Quote</Trans>
                </Button>
                <Button
                  variant="primary"
                  centerText={true}
                  href={urls.serviceLinks.brochures.href}
                  full={true}
                  data-content-piece="view_the_brochures"
                >
                  <Trans>View the Brochures</Trans>
                </Button>
              </div>
            </div>
            <div className={styles.footerNavs}>
              {urls.footerLinks.map((link) => (
                <FooterNav
                  key={link.title}
                  label={link.title}
                  links={link.children as INavLinks}
                ></FooterNav>
              ))}
            </div>
          </div>
          <div className={styles.subFooter}>
            <SubFooter links={urls.subFooterLinksLinks} searchUrl={searchUrl} />
          </div>
          <div className={styles.cdcDisclaimerContainer}>
            <p>
              NOTICE:&nbsp;&nbsp;
              <strong>For U.S. cruises and guests</strong>: Prior to booking,
              please consult all applicable U.S. Centers for Disease Control
              travel advisories, warnings, or recommendations relating to cruise
              travel, available at{" "}
              <a
                href="http://www.cdc.gov/travel/notices"
                target="_blank"
                rel="noopener noreferrer"
              >
                http://www.cdc.gov/travel/notices
              </a>
              . If a certain threshold level of COVID-19 is detected onboard
              your cruise ship during your voyage, your voyage will be ended
              immediately and the ship will return to the port of embarkation,
              and your subsequent travel, including your return home, may be
              restricted or delayed.
            </p>
            <p>
              <strong>For cruises and guests worldwide</strong>: Health and
              safety protocols, guest conduct rules, and regional travel
              restrictions vary by ship and destination, and are subject to
              change without notice. Due to evolving health protocols, imagery
              and messaging may not accurately reflect onboard and destination
              experiences, offerings, features, or itineraries. These may not be
              available during your voyage, may vary by ship and destination,
              and may be subject to change without notice.
            </p>
          </div>
        </SectionContainer>
      </footer>
    </React.Fragment>
  );
};
